export const hasPlansToManage = (clubs = []) =>
  clubs.some(
    (club) =>
      !club.is_personal || club.has_created_event === true || Number(club.event_count || 0) > 0
  );
